// extracted by mini-css-extract-plugin
module.exports = {"modeFormTitle":"GestureControl_modeFormTitle__lc5XL","volume":"GestureControl_volume__5tXZA","startBtn":"GestureControl_startBtn__21SBO"};